import { ReactElement, ReactNode } from 'react';
import { Tooltip, Typography, Box, ClickAwayListener } from '@mui/material';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { useModal } from '../../contexts/ModalContext';

const styles = {
  container: {
    p: 2,
  },
  content: {
    typography: 'body3',
  },
};

type ContentModalProps = {
  content: ReactNode;
  closeModal?: () => void;
};

const ContentModal = ({ content, closeModal }: ContentModalProps) => {
  const handleClickAway = (_event: MouseEvent | TouchEvent) => {
    closeModal?.();
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box sx={styles.container}>
        <Typography sx={styles.content}>{content}</Typography>
      </Box>
    </ClickAwayListener>
  );
};

type ResponsiveTooltipProps = {
  content: ReactNode;
  children: ReactElement;
};

export const ResponsiveTooltip = ({ content, children }: ResponsiveTooltipProps) => {
  const { isMobile } = useBreakpoints();
  const { openModal } = useModal();

  const handleOpen = () => {
    openModal(<ContentModal content={content} />);
  };

  if (isMobile) {
    return (
      <Box
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          handleOpen();
        }}
      >
        {children}
      </Box>
    );
  }

  return <Tooltip title={content}>{children}</Tooltip>;
};
